import { makeStyles } from '@material-ui/core/styles'
import { DASHBOARD, VIDEO_VISIT_REARRANGEMENT, VISIT_PANEL_ACTIONS_REARRANGEMENT } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  chatRoomWrapper: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'center',
    background: '#D1D6DE',
    paddingX: '1.5em',
    height: 'calc( 100vh - 275px )',
    overflow: 'none',
    [theme.breakpoints.down(DASHBOARD)]: {
      height: 'calc( 100vh - 425px )',
    },

    [theme.breakpoints.down(VISIT_PANEL_ACTIONS_REARRANGEMENT)]: {
      height: 'calc( 100vh - 475px )',
    },

    [theme.breakpoints.down(VIDEO_VISIT_REARRANGEMENT)]: {
      height: 'calc( 100vh - 550px )',
    },
  },
  videoRoomWrapper: {
    display: 'flex',
    flex: '0 0 auto',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    background: '#D1D6DE',
    padding: '1.5em',
    [theme.breakpoints.down(1090)]: {
      padding: '0.4em',
    },
    maxHeight: '60vh',
    minHeight: '300px',
    /* tricky hack to set block aspect ratio for video */
    height: 'calc( 55vw - 300px )',

    [theme.breakpoints.down(DASHBOARD) + 50]: {
      height: '50vh',
      minHeight: '50vh',
      flex: '0 0 auto',
    },

    [theme.breakpoints.down(VIDEO_VISIT_REARRANGEMENT)]: {
      height: '60vh',
      minHeight: '60vh',
      flex: '0 0 auto',
      /* for buttons */
      paddingBottom: '5em',
    },
  },
  compactVideo: {
    minWidth: '12em',
  },
  cancelButton: {
    color: theme.palette.error.secondary,
    borderColor: theme.palette.error.secondary,
    '&:hover': {
      borderColor: theme.palette.error.secondary,
    },
  },
}))

export default useStyles
